const COACH_USER_TYPE = 'Coach'

/**
 * The coach a golfer can mute promotions from: the other member of a 1:1
 * conversation, when that member is a coach. Coaches never get this control.
 */
export const promotionCoach = (channel, user, isCoach) => {
  if (!user || isCoach) return null
  const members = Object.values(channel?.state?.members || {})
  if (members.length !== 2) return null
  const other = members.find(member => member.user?.id !== user.externalId)
  if (other?.user?.type !== COACH_USER_TYPE) return null
  return { externalId: other.user.id, name: other.user.name || 'your coach' }
}

export const firstName = name =>
  (name || '').trim().split(/\s+/)[0] || 'your coach'
